/*
  import { List as ListRoles } from '@/services/AccountSettings/Role/List'

  const { list } = await ListRoles ({
    hoaID
  });
*/

import kms from '@/services/kms'
import _get from 'lodash/get'

export async function List({ hoaID, accountManagingUserID }) {
  let params = {
    hoaID
  }

  if (typeof accountManagingUserID === 'number' && accountManagingUserID >= 1) {
    params.accountManagingUserID = accountManagingUserID
  }

  try {
    let result = await kms.get('/AccountSettings/Role/List', {
      params
    })

    return {
      list: _get(result, 'results', [])
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    list: []
  }
}
